import { EMPTY_CHARGE_DETAIL_MODEL } from 'presentation/model/ChargeDetailMaintenance/ChargeDetailModel';
import { useState } from 'react';
import {createContainer} from "react-tracked";

const {
    Provider: ChargeDetailProvider,
    useTracked: useChargeDetailTracked
} = createContainer(() => useState(EMPTY_CHARGE_DETAIL_MODEL), {concurrentMode: true});
export {ChargeDetailProvider, useChargeDetailTracked};